/* eslint-disable no-new */
import $ from 'jquery'
import mapStyles from './map_styles'
import util from './_util'

// create empty LatLngBounds object
let bounds

window.initMap = () => {
  const google = window.google
  bounds = new google.maps.LatLngBounds()
  var mapProp = {
    zoom: 3,
    scrollwheel: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    styles: mapStyles,
  }
  const map = new google.maps.Map(
    document.getElementById('regions-map'),
    mapProp
  )
  run(google, map)
}

const run = (google, map) => {
  let content = ''
  util.popupCarouselStyles()
  $.getJSON(`json/data.json?${Date.now()}`, (data) => {
    data.forEach((item, index) => {
      content += util.getCarouselSlide(item, index)
      const marker = new google.maps.Marker({
        position: { lat: item.latitude, lng: item.longitude },
        map: map,
        popup: `popup-${index + 1}`,
      })

      // extend the bounds to include each marker's position
      bounds.extend(marker.position)

      google.maps.event.addListener(marker, 'click', () => {
        $('.popup').removeClass('active')
        $('#' + marker.popup).addClass('active')
        util.initPopupCarousel(`#${marker.popup} .popup_carousel`)
      })

      util.initPopup(item, index)
    })

    // now fit the map to the newly inclusive bounds
    map.fitBounds(bounds)

    // (optional) restore the zoom level after the map is done scaling
    var listener = google.maps.event.addListener(map, 'idle', () => {
      map.setZoom(3)
      google.maps.event.removeListener(listener)
    })

    util.initCarousel(content)
    util.initCarouselEvent()
    util.initPopupClose()
  })
}
